import { createStore } from "vuex";
import products from "./modules/products";
import contact from "./modules/contact";
import { admin } from "./modules/admin";
import { productsAdmin } from "./modules/productsAdmin";
import { contactsAdmin } from "./modules/contactsAdmin";

export default createStore({
  modules: {
    products,
    contact,
    admin,
    productsAdmin,
    contactsAdmin
  }
});
